module.exports = __webpack_public_path__ + "static/img/cloud.db67603f.png";